import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CartService} from '../../service/cart/cart.service';
import {ResponsiveService} from '../../service/utility/responsive/responsive.service';
import {IRace} from '../../models/race.interface';

export interface DialogData {
  text: string;
  title: string;
  type: string;
  symbol?: string;
  qAcc?: any;
  race?: IRace;
}

@Component({
  selector: 'app-data-dialog-confirm',
  templateUrl: './data-dialog-confirm.component.html',
})


export class DataDialogConfirmComponent implements OnInit {

  constructor(
      @Inject(MAT_DIALOG_DATA) public data: DialogData,
      private cartService: CartService,
      private dialogRef: MatDialogRef<DataDialogConfirmComponent>,
      public responsiveService: ResponsiveService
  ) { }

  ngOnInit() {
    // console.log(this.cartService.cartSystem);
  }

  addBet(quote, scommessa) {
    this.dialogRef.close({
      data: {
        quote: quote,
        scommessa: scommessa
      }
    });
  }

  checkQuotaMigliore(qm) {
    return Number(this.cartService.cartSystem.pag) === Number(qm / 100 * (this.cartService.cartSystem.pun / this.cartService.cartSystem.sco[0].cb));
  }

}
